/* COH Custom-Konfigurator – Warenkorb: Custom-Glaspositionen wie die übrigen Glaszeilen darstellen (ohne Bild, ohne eigene Bedienelemente), Artikelzahl auf der Warenkorbseite nur mit Fassungen. */
(function () {
  'use strict';
  var IDS = ['53900434997514', '53900435194122', '53900435259658', '53900435292426', '53900435325194', '53900435423498'];
  var queued = false;
  function mark() {
    var rows = document.querySelectorAll('cart-item');
    for (var k = 0; k < rows.length; k++) {
      if (IDS.indexOf(rows[k].getAttribute('data-variant-id')) > -1 && !rows[k].hasAttribute('data-gc-glass')) rows[k].setAttribute('data-gc-glass', '');
    }
  }
  function fixHeader() {
    var els = document.querySelectorAll('.cart-items__header-product-count');
    if (!els.length) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var hasGlass = false, n = 0;
      c.items.forEach(function (x) {
        if (x.properties && x.properties._glas_rolle === 'glas') hasGlass = true; else n += x.quantity;
      });
      if (!hasGlass) return;
      els.forEach(function (e) {
        var t = e.textContent;
        var nt = t.replace(/\d+/, String(n));
        if (t !== nt) e.textContent = nt;
      });
    }).catch(function () { });
  }
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; mark(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', function () { mark(); fixHeader(); });
  setInterval(fixHeader, 1200);
  mark();
})();
